<div class="grid-item-lookup">
  <div class="d-inline-flex align-items-center position-relative">
    <input
      #searchBar
      type="search"
      class="form-control shadow-none"
      [placeholder]="customPlaceholder || 'Search...'"
      (input)="search(searchBar.value)"
    />
    <button 
      class="clear-btn position-absolute" 
      *ngIf="searchBar.value"
      (click)="clearInput(searchBar)"
    >✕</button>
  </div>
</div>
